export function clamp(v: number, min: number, max: number): number {
  return v < min ? min : v > max ? max : v;
}

export function clamp01(v: number): number {
  // Guards against NaN reaching the renderer, which would poison a canvas path.
  return Number.isFinite(v) ? clamp(v, 0, 1) : 0;
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/**
 * Frame-rate independent exponential ease toward `target`.
 *
 * @param tau Time constant in seconds — roughly how long to cover ~63% of the
 *   remaining distance. Smaller is snappier.
 */
export function approach(
  current: number,
  target: number,
  dt: number,
  tau: number,
): number {
  if (tau <= 0) return target;
  return lerp(current, target, 1 - Math.exp(-dt / tau));
}

export function smoothstep(edge0: number, edge1: number, v: number): number {
  const t = clamp((v - edge0) / (edge1 - edge0), 0, 1);
  return t * t * (3 - 2 * t);
}

/** 0..1 -> 0..1, a full smooth in-out cycle. */
export function easeInOutSine(t: number): number {
  return 0.5 - 0.5 * Math.cos(t * Math.PI * 2);
}

/** Mod that keeps the result positive, for wrapping angles. */
export function wrap(v: number, span: number): number {
  return ((v % span) + span) % span;
}
